// extracted by mini-css-extract-plugin
export default {"images":"images__iGNbr","bg":"bg__p1o5q","mainImage":"mainImage__9imsA","loaded":"loaded__4XSCS"};